"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initSliders = undefined;

var _Dom = require("common/Dom");

var _Dom2 = _interopRequireDefault(_Dom);

var _slickCarousel = require("slick-carousel");

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initSliders = exports.initSliders = function initSliders() {
    $(_Dom2.default.slickSlider).slick();
};